<script lang="ts">
  import InputNumber from "primevue/inputnumber";
  import Message from "@/ui/message/message.vue";
  import { useField } from "vee-validate";
  import { PropType, watch } from "vue";

  InputNumber.components.InputText.compatConfig = {
    MODE: 3,
  };

  InputNumber.compatConfig = {
    MODE: 3,
    COMPONENT_V_MODEL: false,
  };

  export default {
    components: { InputNumber, Message },
    props: {
      label: {
        type: String,
        default: "",
      },
      name: {
        type: String,
        default: "",
      },
      mode: {
        type: String,
        default: "decimal",
      },
      currency: {
        type: String,
        default: "EUR",
      },
      locale: {
        type: String,
        default: "nl-NL",
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      prefix: {
        type: String,
        default: "",
      },
      classes: {
        type: Object as PropType<{ input: string; label: string }>,
        default: undefined,
      },
      maxFractionDigits: {
        type: Number,
        default: 0,
      },
    },
    setup(props) {
      const { value: localValue, errorMessage, meta, handleBlur: fieldBlur, setValue } = useField(() => props.name);

      return {
        localValue,
        errorMessage,
        meta,
        fieldBlur,
        setValue,
        name: props.name,
      };
    },
  };
</script>

<template>
  <div class="flex flex-col gap-[4px] w-full">
    <label v-if="label" :for="name" :class="['text-[14px] font-normal', classes?.label]">
      {{ label }}
      <span v-if="required" class="text-[#FF55C6]">*</span>
    </label>
    <InputNumber v-bind="$props" v-model="localValue" :inputId="name" :invalid="!!errorMessage" :class="['h-[40px]', classes?.input]" />
    <Message v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>
